import React from "react";
import { connect } from 'react-redux';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from 'react-router-dom';
/* import { Multiselect } from "multiselect-react-dropdown"; */
import { getPortList, getPortTypeList } from "../Actions/PortManagementAPI";
import { getZoneList } from "../Actions/VendorManagementAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import $ from "jquery"

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
    PortName: "",
    Country: "",
    /* PortType:[], */
    PageNumber: 1,
    PageSize: 20
}
class EditPort extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            portId: 0,
            portName: "",
            country: "",
            /*  portType:[], */
            isDeleted: false,
            modifiedBy: currentuser.name,
            zoneId: 0,
            zoneListData: []
        }
        this.UpdatePort = this.UpdatePort.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { PortDetail, dispatch } = nextProps;
        if (PortDetail && PortDetail !== "") {
            prevState.portId = PortDetail.portId;
            prevState.portName = PortDetail.portName;
            prevState.country = PortDetail.country;
            prevState.zoneId = PortDetail?.zoneId;
            /*    prevState.portType=PortDetail.PortType; */
            dispatch({ type: "getPortDetailSuccess", data: "" });
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({ type: "SubBannerTitle", data: "Port" });
        this.getZoneList();
        // dispatch(getZoneList());
        /*   dispatch(getPortTypeList()); */
    }

    getZoneList = () => {
        let url = `${API.equipmentLookups}?lookupType=${"contract type"}`;
        axios.get(url).then((response) => {
            let findId = response.data?.filter((item) => item.lookUpName === "FZM")[0]?.lookUpId;
            let url1 = `${API.equipmentLookups}?lookupType=${"plan type"}&parentId=${findId}`;
            axios.get(url1).then((response) => {
                this.setState({ zoneListData: response.data });
            });
        });
    }

    UpdatePort() {
        const { dispatch, t } = this.props;
        if (this.state.portName !== "" &&  this.state.country !== "" && this.state.zoneId > 0) {
        let url = `${API.postPort}`;
        axios.put(url, this.state)
            .then((response) => {
                dispatch(getPortList(searchData));
                this.hideSidePanel();
                toast.success(`${t("CommonText.CommonUpdate")}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch({
                    type: "putPortDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putPortDetailFailure",
                    error: "ERROR"
                })
            })
        }
        else {
            if (this.state.portName == "") {
                $("#portNameErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
            }
            else{
                $("#portNameErrMsg").text("");
            }
            if (this.state.country == "") {
                $("#countryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
            }
            else{
                $("#countryErrMsg").text("");
            }
            if (this.state.zoneId <=0) {
                $("#zoneIdErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
            }
            else{
                $("#zoneIdErrMsg").text("");
            }
        }

    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.setState({
            [nodeName]: nodeName == "zoneId" ? parseInt(e.target.value) : e.target.value
        })
    }
    /*    onSelectChange(item) {
          this.setState({portType:item});
       }
       
       onRemoveChange(item) {
          this.setState({portType:item});
       } */

    render() {
        const { t, zoneList } = this.props;
        /*     const { portTypeList } =this.props;
          const { portType } = this.state; */
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='col-lg-12'>
                        <div className="panel-box search-filter-box">
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>{t("PortManagementScreenContent.EditPort")}</h5>
                                </div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-4">
                                    <label className="form-label required">{t("TopPaneContent.Port")}</label><br></br>
                                    <input type="text" className="form-control" name='portName' value={this.state.portName} placeholder={t("TopPaneContent.Port")} onChange={e => this.handleInputChange(e)}></input>
                                    <span id="portNameErrMsg" className="spanErrMsg"></span>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label required">{t("EquipmentServiceTypes.Country")}</label><br></br>
                                    <input type="text" className="form-control" name='country' value={this.state.country} placeholder={t("EquipmentServiceTypes.Country")} onChange={e => this.handleInputChange(e)}></input>
                                    <span id="countryErrMsg" className="spanErrMsg"></span>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label required">{t("ZoneScreen.Title")}</label>
                                    <br></br>
                                    <select
                                        className="form-control"
                                        name="zoneId"
                                        value={this.state.zoneId}
                                        onChange={e => this.handleInputChange(e)}
                                    >
                                        <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                                        {this.state.zoneListData?.length > 0 &&
                                            this.state.zoneListData?.map((zonename) => (
                                                <option value={zonename.lookUpId}>
                                                    {zonename.lookUpName}
                                                </option>
                                            ))}
                                    </select>
                                    <span id="zoneIdErrMsg" className="spanErrMsg"></span>
                                </div>
                                {/*  <div className="col-lg-4">
                                    <label className="form-label">Type</label><br></br>
                                    <Multiselect
                             options={portTypeList??[]} 
                            isObject={false}
                            style={{
                              option: {
                                "margin-right": 0,
                                display: "block",
                                "font-weight": "normal",
                              },
                              chips: { "background-color": "#1a3464" },
                            }}
                            onSelect={(item) => this.onSelectChange(item)}
                            onRemove={(item) => this.onRemoveChange(item)}
                            showArrow={true}
                            selectedValues={portType}
                            placeholder={
                              this.state.Ships && this.state.Ships.length
                                ? ""
                                : "Select"
                            }
                            closeIcon="cancel"
                          />
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.UpdatePort()}> {t("EquipmentServiceTypes.Update")} </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> {t("ComplianceandBudgetScreen.Cancel")} </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.goBack();
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        PortDetail: state.MasterScreenReducer.PortDetail,
        zoneList: state.VendorManagementReducer.zoneList,
        /* portTypeList: state.MasterScreenReducer.PortType || [],  */
    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(EditPort)));